// Foundations
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationRequestService } from '../../../services/reservation/reservation-request.service';

// Components

// Models

@Component({
  selector: 'app-reservation-thank-you',
  templateUrl: './reservation-thank-you.component.html',
  styleUrls: ['./reservation-thank-you.component.scss'],
})
export class ReservationThankYouComponent implements OnInit {

  @Input() locationName: string;

  constructor(
    private router: Router,
    public reservation: ReservationRequestService
  ) {}

  ngOnInit(): void {}

  // Private methods
  // ------------------------------------------------------------------------------------

  // Public methods
  // ------------------------------------------------------------------------------------
  onSave(): void {
    this.router.navigateByUrl('/');
  }
}
